import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { FileType } from '../models/fileType';
import { Pagination } from '../models/pagination';
import { Talent } from '../models/talent';
import { FilterTalentsForm } from '../pages/Talents/FilterTalents';

const baseUrl = '/talent';

const getTalentById = (id: number): Promise<AxiosResponse<Talent>> =>
  axios.get<Talent>(`${baseUrl}/${id}`);

const getCurrentTalent = (): Promise<AxiosResponse<Talent>> =>
  axios.get<Talent>(`${baseUrl}/current`);

const updatePaymentInformation = (
  talent: Talent
): Promise<AxiosResponse<{ data: string; status: number }>> => {
  return axios.put<{ data: string; status: number }>(`${baseUrl}`, talent);
};

const getTalentList = (
  config?: AxiosRequestConfig
): Promise<AxiosResponse<Talent[]>> =>
  axios.get<Talent[]>(`${baseUrl}`, config);

const getTalents = (
  data?: FilterTalentsForm,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<Pagination<Talent>>> =>
  axios.post<Pagination<Talent>>(`${baseUrl}/filter`, data, config);

const exportTalents = (
  data?: FilterTalentsForm
): Promise<AxiosResponse<string>> =>
  axios.post<string>(`${baseUrl}/export`, data, { responseType: 'blob' });

const exportTalentTemplate = (): Promise<AxiosResponse<string>> =>
  axios.get<string>(`${baseUrl}/template`, { responseType: 'blob' });

const addTalentAttachment = (
  talentId: number,
  attachments: FormData
): Promise<AxiosResponse<FileType[]>> =>
  axios.post<FileType[]>(`${baseUrl}/files/${talentId}`, attachments);

const createTalent = (payload: Talent): Promise<AxiosResponse<Talent>> =>
  axios.post<Talent>(`${baseUrl}`, payload);

const updateTalent = (payload: Talent): Promise<AxiosResponse<Talent>> =>
  axios.put<Talent>(`${baseUrl}`, payload);

const deleteTalent = (id: number): Promise<AxiosResponse<Talent>> =>
  axios.delete<Talent>(`${baseUrl}/${id}`);

const uploadTalents = (payload: FormData): Promise<AxiosResponse<string[]>> =>
  axios.post<string[]>(`${baseUrl}/import`, payload);

export const talentService = {
  getTalentById,
  updatePaymentInformation,
  getTalentList,
  getTalents,
  exportTalents,
  addTalentAttachment,
  getCurrentTalent,
  exportTalentTemplate,
  createTalent,
  updateTalent,
  deleteTalent,
  uploadTalents
};
